/**
 * FlahaSOIL v2 — Evidence completeness chart adapter (Phase 10C-D).
 */
import type { ScientificCoverage } from "@flaha/shared-types";
import type { ScientificChartData, ScientificChartStatus } from "../types/ScientificChartTypes";

export function evidenceCompletenessChartAdapter(
  coverage: ScientificCoverage | null | undefined
): ScientificChartData<ScientificCoverage | null> {
  let status: ScientificChartStatus = "READY";

  if (!coverage) {
    status = "MISSING_DATA";
  }

  return {
    status,
    title: "Scientific Evidence Completeness",
    description: "Status of scientific modules based on the requested test level.",
    data: coverage ?? null,
    warnings: [],
    units: { coverage: "%" },
    source: "FlahaSOIL Evidence Contract",
    accessibilitySummary: coverage 
      ? `Scientific coverage is ${coverage.level.coveragePercent.toFixed(1)}%. Status: ${coverage.level.status}.`
      : "No coverage data available.",
  };
}
